// extracted by mini-css-extract-plugin
export var logo = "_ky-2";
export var logoWrapper = "_ky-1";
export var strip = "_ky-0";